// extracted by mini-css-extract-plugin
export var textInput = "_ky-0";